import * as actionTypes from '../actions/actionTypes'
const initState = {
    response: [],
    message: "",
    type: "",
}

export default (state = initState, action = {}) =>
{
    switch (action.type)
    {
        case actionTypes.GET_PROFILE_REQUEST:

            return {
                ...state,
                type: "",
                response: [],
                message: 'request',
            }
        case actionTypes.GET_PROFILE_SUCCESS:

            return {
                ...state,
                type: "getData",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.GET_PROFILE_ERROR:

            return {
                ...state,
                type: "",
                response: action.payload.response.data,
                message: 'Error',
            }
        case actionTypes.UPDATE_PROFILE_REQUEST:

            return {
                ...state,
                type: '',
                response: [],
                message: 'request',
            }
        case actionTypes.UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                type: "updateData",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.UPDATE_PROFILE_ERROR:

            return {
                ...state,
                response: action.payload.response.data,
                message: 'Error',
            }
        case actionTypes.CHECKUSER_URL_REQUEST:

            return {
                ...state,
                type: '',
                response: [],
                message: 'request',
            }
        case actionTypes.CHECKUSER_URL_SUCCESS:
            return {
                ...state,
                type: "checkUrl",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.CHECKUSER_URL_ERROR:

            return {
                ...state,
                type: '',
                response: action.payload.response.data,
                message: 'Error',
            }
        case actionTypes.UPDATEUSER_URL_REQUEST:

            return {
                ...state,
                type: '',
                response: [],
                message: 'request',
            }
        case actionTypes.UPDATEUSER_URL_SUCCESS:
            return {
                ...state,
                type: "updateUrl",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.UPDATEUSER_URL_ERROR:

            return {
                ...state,
                type: '',
                response: action.payload.response.data,
                message: 'Error',
            }
        case actionTypes.DEACTIVATE_ACCOUNT_REQUEST:

            return {
                ...state,
                type: 'request',
                response: [],
                message: 'request',
            }
        case actionTypes.DEACTIVATE_ACCOUNT_SUCCESS:
            return {
                ...state,
                type: "deactiveAccount",
                response: action.payload.data,
                message: 'Success Data',
            }
        case actionTypes.DEACTIVATE_ACCOUNT_ERROR:

            return {
                ...state,
                response: action.payload.response.data,
                message: 'Error',
            }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/Profile.js